import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
    getAdminEmpresa, getFinanceiroCaixa,
    getFinanceiroAgencia,
    getOperadorEmpresa,
    getPerfisVendedores, getVendedorAgencia, getVendedorEmpresa,
    PERFIL_ADMIN,
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';

import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import { getFinanceiroEmpresa } from '../../security/securityContext';

export class MenuBagagem extends Component {

    render() {
        return (
            <div className="area-home">
                <Titulo texto="Bagagem extras" urlRetorno="/gestao-empresa" />
                <div className="row sistemas">
                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        ...getPerfisVendedores(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-pesquisar-bilhete">
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <i className="material-icons custom-icons">&#xe8b6;</i>
                                        <h5 className='nm-longo-resize'>
                                            Nova bagagem
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Autorizacao>
                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroCaixa(this.props.empresaSelecionada.id),
                        getFinanceiroAgencia(this.props.empresaSelecionada.id),
                        getFinanceiroEmpresa(this.props.empresaSelecionada.id),
                        getVendedorAgencia(this.props.empresaSelecionada.id),
                        getVendedorEmpresa(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-bagagem">
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <i className="material-icons custom-icons"><QueryStatsOutlinedIcon className='css-icon' /></i>
                                        <h5 className='nm-longo-resize'>
                                            Gerenciar bagagem
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Autorizacao>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication
    }
}


export default withRouter(connect(mapStateToProps)(MenuBagagem));
